import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { useRequest } from "@components/AppHook";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function ModerateMicroreviewScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:microreview:list"));
    const { api_post } = useRequest();
    const { setDelData } = useAppContext();

    if (!apiData) return;

    const togglePublish = (ev, post_id) => {
        ev.preventDefault();
        api_post(null, apiUrl, {
            params: { id: post_id, action: "toggle_publish" },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                }
            },
        });
    };

    return (
        <ListingCard header={t("Отзывы по играм")}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "3%" }} />
                        <th style={{ width: "40%" }}>{t("Отзыв")}</th>
                        <th>{t("Действия")}</th>
                        <th>{t("Игра")}</th>
                        <th>{t("Автор")}</th>
                        <th>{t("Дата добавления")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => (
                        <tr key={o.id}>
                            <td>
                                <span className={`b-rating ${o.rating_class}`}>{o.rating_txt}</span>
                            </td>
                            <td>
                                <div style={{ maxWidth: "600px", whiteSpace: "pre-line" }}>{o.text}</div>
                            </td>
                            <td>
                                <span className="mr-3">
                                    <a href="#" onClick={(ev) => togglePublish(ev, o.id)}>
                                        {o.is_published ? (
                                            <Awesome type="toggle-on" tooltip={t("Снять с публикации")} />
                                        ) : (
                                            <Awesome type="toggle-off" color="black" tooltip={t("Опубликовать")} />
                                        )}
                                    </a>
                                </span>
                                <span className="mr-3">
                                    <Link
                                        to={url_reverse("games:microreview:edit", {
                                            game_id: o.game_id,
                                            microreview_id: o.id,
                                        })}
                                    >
                                        <Awesome type="pencil" />
                                    </Link>
                                </span>
                                <span>
                                    <Awesome
                                        type="trash-o"
                                        color="red"
                                        onClick={() => setDelData({ url: apiUrl + "?ids=" + o.id })}
                                    />
                                </span>
                            </td>
                            <td>
                                <Link to={url_reverse("games:microreview:list", { game_id: o.game_id })}>
                                    {o.game.base_locale_object.name}
                                </Link>
                            </td>
                            <td>
                                <a
                                    href={`https://admin.vkplay.ru/admin/profiles/?user_id=${o.author_ac_id}`}
                                    target="_blank"
                                >
                                    {o.author_email}
                                </a>
                            </td>
                            <td>{o.date_added}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}
